import SiteScroll from "./SiteScroll";

export const instance = new SiteScroll();

export default { instance };
